import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('highlight-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            backgroundScrollTrigger: null,
            scrollTriggerTitle: null,
            highlightBlock: null,
            highlightBlockBox: null,
            highlightTitleBlock: null,
            highlightTitleBlockBox: null,
            highlightTitleEl: null,
            heightRemovalMultiplier: 0.17,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.highlightBlock = this.$el;
        this.highlightBlockBox = this.highlightBlock.getBoundingClientRect();
        this.highlightTitleBlock = this.$el.querySelector('.highlight__title-block');
        this.highlightTitleBlockBox = this.highlightTitleBlock.getBoundingClientRect();
        this.highlightTitleEl = this.$el.querySelector('.highlight__title-holder');

        const multiplier = gsap.utils.clamp(3.7, 1, window.innerWidth / 1920);

        this.backgroundScrollTrigger = gsap.timeline({
            scrollTrigger: {
                trigger: this.highlightTitleBlock,
                start: 'top top',
                end: this.highlightTitleBlockBox.bottom - (this.highlightTitleBlockBox.height * this.heightRemovalMultiplier),
                scrub: true,
            },
        });

        this.backgroundScrollTrigger
            .to(this.highlightBlock, {
                duration: 1.55,
                backgroundColor: '#fff',
                ease: 'power1.out',
            })
            .to(this.highlightTitleEl, {
                duration: 1.55,
                color: '#782a44',
                ease: 'power1.out',
            }, '<');

        this.scrollTriggerTitle = gsap.timeline({
            scrollTrigger: {
                trigger: this.highlightTitleEl,
                start: '80% 50%',
                end: this.highlightBlockBox.bottom - (this.highlightTitleBlockBox.height * multiplier),
                scrub: true,
                pin: true,
            },
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {},
});
